// src/pages/authn/AuthnEditPage.tsx
// OAuth2Client edit — routed wrapper kept for the existing /authns/:id/edit URL
// (same pattern as ChatCreatePage): renders the form-kit edit dialog
// (features/authn/ClientEditDialog) always-open; closing or saving returns to
// the client detail page, exactly like the old Card form did.

import { useParams, useNavigate } from 'react-router-dom';
import { observer } from '@react';
import { ClientEditDialog } from '@/features/authn/ClientEditDialog';

export const AuthnEditPage = observer(() => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const back = () => navigate(`/authns/${id}`);

  return <ClientEditDialog open clientId={id ?? ''} onClose={back} onSaved={back} />;
});

export default AuthnEditPage;
